module.exports = __webpack_public_path__ + "img/119.2.b4596bfe.png";